import CyberFirstContainer from './CyberFirstContainer';

export default CyberFirstContainer;
